import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueProgressBar from 'vue-progressbar';

import constants from '@/constants';

import router from '@/router';
import store from '@/store';

import App from '@/App.vue';
import '@/filters';

axios.defaults.baseURL = constants.baseUrl;

Vue.use(VueAxios, axios);

Vue.use(VueProgressBar, {
  autoFinish: false,
  color: '#000',
  thickness: '3px',
  transition: {
    speed: '0.4s',
    opacity: '0.6s',
    termination: 500
  }
});

Vue.config.productionTip = false;
Vue.prototype.$isTouchDevice = 'ontouchstart' in document.documentElement;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

console.log('Coded with ❤ by Guillaume Kpomda');